import {
  Card,
  CardContent,
  CardContentDescription,
  CardHeader,
  CardTitle,
} from '@/components/Card'
import { Button } from '@/components/Button'
import { ProgressBar } from '@/components/ProgressBar'
import { Tooltip } from '@/components/Tooltip'
import { Icon } from '@/components/Icon'
import type { BookkeepingStepInfo } from './BookkeepingProgressionViewModel'

export interface BookkeepingProgressionCardProps {
  bookkeepingStepInfo: BookkeepingStepInfo
  primaryActionTestId?: string
  secondaryActionTestId?: string
}

export function BookkeepingProgressionCard({
  bookkeepingStepInfo,
  primaryActionTestId,
  secondaryActionTestId,
}: BookkeepingProgressionCardProps) {
  return (
    <Card>
      <BookkeepingProgressionCardContent
        bookkeepingStepInfo={bookkeepingStepInfo}
        primaryActionTestId={primaryActionTestId}
        secondaryActionTestId={secondaryActionTestId}
      />
    </Card>
  )
}

interface BookkeepingProgressionCardContentProps {
  bookkeepingStepInfo: BookkeepingStepInfo
  primaryActionTestId?: string
  secondaryActionTestId?: string
}

function BookkeepingProgressionCardContent({
  bookkeepingStepInfo,
  primaryActionTestId,
  secondaryActionTestId,
}: BookkeepingProgressionCardContentProps) {
  return (
    <>
      <CardHeader>
        <CardTitle>
          {bookkeepingStepInfo.title}&nbsp;
          {bookkeepingStepInfo.tooltip && (
            <Tooltip content={bookkeepingStepInfo.tooltip}>
              <Icon size={14} name="info-blue" color="var(--blue400)" />
            </Tooltip>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ProgressBar
          key={1}
          bars={[
            {
              progress: bookkeepingStepInfo.percentDone,
            },
            {
              progress: bookkeepingStepInfo.percentPending,
              style: 'striped',
            },
          ]}
        />
      </CardContent>
      <CardContent>
        <CardContentDescription>
          {bookkeepingStepInfo.description}
        </CardContentDescription>
      </CardContent>
      {bookkeepingStepInfo.secondaryAction && (
        <CardContent compactBottomPadding>
          <Button
            label={bookkeepingStepInfo.secondaryActionText ?? ''}
            variant="default"
            size="wide-slim"
            onPress={bookkeepingStepInfo.secondaryAction}
            testId={secondaryActionTestId}
          />
        </CardContent>
      )}
      {bookkeepingStepInfo.primaryAction && (
        <CardContent>
          <Button
            label={bookkeepingStepInfo.primaryActionText ?? ''}
            variant="primary"
            onPress={bookkeepingStepInfo.primaryAction}
            size="wide-slim"
            testId={primaryActionTestId}
          />
        </CardContent>
      )}
    </>
  )
}
